export const Dropdown = {
	selectors: {
		dropdownToggle: Array.prototype.slice.call(document.querySelectorAll('.js-dropdown-toggle'))
	},
	init: function() {
		this.toggleDropdown(this.selectors.dropdownToggle);
	},

	getArrowElements: function () {
		let elements = [];
		let tnsControls = document.querySelectorAll('.tns-controls');
		if (tnsControls.length) {
			elements = [tnsControls[0].querySelectorAll('button')[1], tnsControls[1].querySelectorAll('button')[0], tnsControls[1].querySelectorAll('button')[1]];
		}
		return elements;
	},

	toggleDropdown: function(_selector) {
		let self = this;

		document.body.addEventListener('click', function(event) {
			self.closeOthersDropdowns(_selector);
		});

		_selector.forEach((x) => {
			x.addEventListener('click', function(event) {
				event.stopPropagation();

				let isOpenedDropdowns = self.detectOpenedDropdowns(_selector);
				let arrowElements = self.getArrowElements();

				if (!this.parentElement.classList.contains('is-open') && isOpenedDropdowns === true) {
					self.closeOthersDropdowns(_selector);

					setTimeout(() => {
						this.parentElement.classList.add('is-open');
						if (arrowElements) {
							arrowElements.forEach(function (element) {
								element.style.display = 'none';
							})
						}
					}, 300)
				}

				else if (this.parentElement.classList.contains('is-open')) {
					self.closeOthersDropdowns(_selector);
					if (arrowElements) {
						arrowElements.forEach(function (element, index) {
							element.style.display = 'block';
							if (index === arrowElements.length - 1) {
								element.style.top = '-30px';
								element.style.position = 'relative';
							}
						})
					}
				}

				else if (!this.parentElement.classList.contains('is-open')) {
					self.closeOthersDropdowns(_selector);

					this.parentElement.classList.add('is-open');
					if (arrowElements) {
						arrowElements.forEach(function (element) {
							element.style.display = 'none';
						})
					}
				}
			})
		});
	},

	closeOthersDropdowns: function(_selector) {
		_selector.forEach((x) => {
			x.parentElement.classList.remove('is-open');
			let arrowElements = this.getArrowElements();
			if (arrowElements) {
				arrowElements.forEach(function (element, index) {
					element.style.display = 'block';
					if (index === arrowElements.length - 1) {
						element.style.top = '-30px';
						element.style.position = 'relative';
					}
				})
			}
		});
	},

	detectOpenedDropdowns: function(_selector) {
		let isOpened = false;

		_selector.forEach((x) => {
			if (x.parentElement.classList.contains('is-open')) {

				isOpened = true;

				return;
			}
		});

		return isOpened;
	}
}

Dropdown.init();
